var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7053_3157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.25 5.25H24.5V1.75C24.5 1.28587 24.3156 0.840752 23.9874 0.512563C23.6592 0.184374 23.2141 0 22.75 0L1.75 0C1.28587 0 0.840752 0.184374 0.512563 0.512563C0.184374 0.840752 0 1.28587 0 1.75L0 21C0 21.4641 0.184374 21.9092 0.512563 22.2374C0.840752 22.5656 1.28587 22.75 1.75 22.75H3.5V26.25C3.5 26.7141 3.68437 27.1592 4.01256 27.4874C4.34075 27.8156 4.78587 28 5.25 28H26.25C26.7141 28 27.1592 27.8156 27.4874 27.4874C27.8156 27.1592 28 26.7141 28 26.25V7C28 6.53587 27.8156 6.09075 27.4874 5.76256C27.1592 5.43437 26.7141 5.25 26.25 5.25ZM1.75 21V1.75H22.75V21H1.75ZM26.25 26.25H5.25V22.75H7V24.5H24.5V7H26.25V26.25ZM12.9412 7.1645C12.9412 7.48417 13.0042 7.80071 13.1265 8.09605C13.2489 8.39138 13.4282 8.65973 13.6542 8.88577C13.8803 9.11182 14.1486 9.29112 14.444 9.41345C14.7393 9.53579 15.0558 9.59875 15.3755 9.59875C16.0211 9.59875 16.6403 9.34229 17.0968 8.88577C17.5533 8.42927 17.8097 7.8101 17.8097 7.1645C17.8097 6.5189 17.5533 5.89974 17.0968 5.44323C16.6403 4.98671 16.0211 4.73025 15.3755 4.73025C14.7299 4.73025 14.1107 4.98671 13.6542 5.44323C13.1977 5.89974 12.9412 6.5189 12.9412 7.1645ZM8.75 8.75L3.5 12.25V19.25H21V10.5L14 14L8.75 8.75Z",
    fill: "#1C4980"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7053_3157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.79e6d0f52aaa50a806a9e4d0379777e3.svg";
export { ForwardRef as ReactComponent };